import { University } from "../../types";

export interface Data {
  TagTypes: typeof TagTypes;
}
export interface Computed {}

export enum TagTypes {
  Selected = "selected",
  Recommended = "recommended"
}
export interface Props {
  university: University;
  type: TagTypes;
}

export interface Methods {
  handleClick: () => void;
}
